import React from "react";
import PropTypes from "prop-types";
import FlipNumbers from 'react-flip-numbers';
import { Carousel } from 'react-responsive-carousel';
import Popover from "../../../common/components/popover/popover.js";


const MerchantImpactTicker = ({ fetchedImpact }) => {

    const displayImpact = (title, message, number, unit, imgClass, noRound) => <>
        <div>
            <div>
                <div className={`w-100 h-185 img-cover ${imgClass}`}>

                </div>
                <div>
                    <h2 className="font-bold color-primary d-flex w-fit center">
                        <FlipNumbers numberStyle={{ fontSize: 20, color: "#A88F6E", fontWeight: "bold" }} height={40} width={22} play perspective={100} numbers={noRound ? Math.floor(number).toLocaleString() : Math.round(number).toLocaleString()} />
                        <span>{unit}</span>
                    </h2>
                    <p> 
                    {message ? <span>Tree Growth Years
                        <Popover content={message}>
                            <svg style={{marginLeft: '5px'}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.7" fillRule="evenodd" clipRule="evenodd" d="M5 10C7.76142 10 10 7.76142 10 5C10 2.23858 7.76142 0 5 0C2.23858 0 0 2.23858 0 5C0 7.76142 2.23858 10 5 10ZM4.8064 7.95528C4.5268 7.95528 4.30014 8.18916 4.30014 8.47767C4.30014 8.76617 4.5268 9.00005 4.8064 9.00005C5.086 9.00005 5.31266 8.76617 5.31266 8.47767C5.31266 8.18916 5.086 7.95528 4.8064 7.95528ZM6.51418 5.38513C7.58745 3.9712 6.79769 2.07667 4.97515 2.00005C4.03232 2.00005 3.2346 2.67387 3.01195 3.58631C2.94367 3.86609 3.17677 4.10354 3.45637 4.10354C3.73597 4.10354 3.952 3.85587 4.08505 3.60212C4.25753 3.27316 4.59393 3.0518 4.97515 3.0518C6.10917 3.14234 6.32518 4.24981 5.49491 5.03687C5.40615 5.10883 5.30085 5.17874 5.19123 5.25152C4.95072 5.41121 4.68941 5.58471 4.53639 5.82393C4.37357 6.06395 4.32296 6.37344 4.30723 6.73645C4.29474 7.02467 4.5268 7.25876 4.8064 7.25876C5.086 7.25876 5.2922 7.02179 5.34297 6.73808C5.37276 6.57161 5.43181 6.41119 5.54891 6.26274C5.66214 6.11498 5.82958 5.98418 6.00423 5.84774C6.18359 5.70763 6.37054 5.56158 6.51418 5.38513Z" fill="black"/>
                            </svg>

                        </Popover></span> : <span className="small-capitalized-text">{title} </span>}
                    </p>
                </div>
            </div>
        </div> </>;

    return (
        <>
            <div className="merchant-impact-section mx-auto">
                <div className="row w-100 mobile-hide">
                    <div className="col-4">
                        {displayImpact('Climate Friendly Products', null, fetchedImpact.impactProgress.carbonOffset.currentCount, null, 'impact-community')}
                    </div>
                    <div className="col-4">
                        {displayImpact('Kg of CO2 Offset', null, fetchedImpact.impactProgress.carbonOffset.currentCount, null, 'impact-CO2')}
                    </div>
                    <div className="col-4">
                        {displayImpact('Trees', `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${Math.floor(fetchedImpact.treeGrowthYears.value).toLocaleString()} trees have in one year.`,
                            fetchedImpact.impactProgress.treeGrowthYears.currentCount, null, 'impact-trees', true)}
                    </div>
                </div>
                <div className="mobile-show">
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true} >
                        <div key="1">
                            {displayImpact('Climate Friendly Products', null, fetchedImpact.impactProgress.carbonOffset.currentCount, null, 'impact-community')}
                        </div>
                        <div key="2">
                            {displayImpact('Kg of CO2 Offset', null, fetchedImpact.impactProgress.carbonOffset.currentCount, null, 'impact-CO2')}
                        </div>
                        <div key="3">
                            {displayImpact('Trees', `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${Math.floor(fetchedImpact.treeGrowthYears.value).toLocaleString()} trees have in one year.`,
                            fetchedImpact.impactProgress.treeGrowthYears.currentCount, null, 'impact-trees', true)}
                        </div>
                    </Carousel>
                </div>
            </div>
        </>
    );
};

MerchantImpactTicker.propTypes = {
    fetchedImpact: PropTypes.object
};


export default MerchantImpactTicker;
